import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 box-shadow border-radius-10 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "pills-tabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "pills-this-week",
  role: "tabpanel",
  "aria-labelledby": "pills-this-week-tab",
  tabindex: "0"
}
const _hoisted_5 = { class: "mb-0 text-end text-dark" }
const _hoisted_6 = { class: "text-success" }

import { useDashboardStore } from '@/stores/dashboard'
import { computed } from "vue"
import { storeToRefs } from "pinia"
import ThisWeekChart from "./ThisWeekChart.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'WeeklyChart',
  setup(__props) {

const { weeklyReceiptCount } = storeToRefs(useDashboardStore())

const totalRevenue = computed(() =>
  weeklyReceiptCount.value?.receiptTotal?.reduce((sum, total) => sum + total, 0) ?? 0
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-title d-flex justify-content-between align-items-center mb-0" }, [
        _createElementVNode("h3", { class: "fw-medium fs-18 mb-0" }, "Receipts"),
        _createElementVNode("ul", {
          class: "ps-0 mb-0 list-unstyled d-flex week-list nav nav-pills",
          id: "pills-tab",
          role: "tablist"
        }, [
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link text-body rounded-0 active",
              id: "pills-this-week-tab",
              "data-bs-toggle": "pill",
              "data-bs-target": "#pills-this-week",
              type: "button",
              role: "tab",
              "aria-controls": "pills-this-week",
              "aria-selected": "true"
            }, " This Week ")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ThisWeekChart, {
            data: _unref(weeklyReceiptCount)?.receiptCount,
            categories: _unref(weeklyReceiptCount)?.selectedDate
          }, null, 8, ["data", "categories"]),
          _createElementVNode("p", _hoisted_5, [
            _cache[0] || (_cache[0] = _createTextVNode(" Total revenue: ", -1)),
            _createElementVNode("span", _hoisted_6, "₵" + _toDisplayString(totalRevenue.value.toFixed(2)), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})